'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectShop = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SelectShop, _Component);

  function SelectShop(props) {
    (0, _classCallCheck3.default)(this, SelectShop);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectShop.__proto__ || (0, _getPrototypeOf2.default)(SelectShop)).call(this, props));

    _this.renderData = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          isBookingAddress = _this$props.isBookingAddress,
          show = _this$props.show,
          onHide = _this$props.onHide,
          titleOverlay = _this$props.titleOverlay,
          activeShop = _this$props.activeShop;

      var display = data;
      if (isBookingAddress) {
        display = isBookingAddress && data && data.map(function (item) {
          return (0, _extends3.default)({}, item, {
            name: item.name.length < 5 ? item.type + ' ' + item.name : item.name
          });
        });
      }
      if (!data || data.length === 0) {
        return _react2.default.createElement('div', null);
      }
      return _react2.default.createElement(
        _components.SlideCustom,
        {
          show: show,
          onHide: onHide,
          title: titleOverlay || 'Chọn chi nhánh'
        },
        display && display.map(function (item) {
          return _react2.default.createElement(_components.ShopItem, {
            key: item._id,
            onClick: _this.onChange,
            data: item,
            active: activeShop && item._id === activeShop._id
          });
        })
      );
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.onShow = _this.onShow.bind(_this);
    _this.onClear = _this.onClear.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SelectShop, [{
    key: 'onChange',
    value: function onChange(shop) {
      var _props = this.props,
          onHide = _props.onHide,
          onChange = _props.onChange;

      onHide();
      onChange(shop);
    }
  }, {
    key: 'onClear',
    value: function onClear(event) {
      event.stopPropagation();
      var onClear = this.props.onClear;

      if (onClear) onClear();
    }
  }, {
    key: 'onShow',
    value: function onShow() {
      var _props2 = this.props,
          disable = _props2.disable,
          onShow = _props2.onShow;

      console.log(disable, onShow);
      if (!disable && onShow) onShow();
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./SelectShop.scss');
      var _props3 = this.props,
          disable = _props3.disable,
          placeHolder = _props3.placeHolder,
          isBookingAddress = _props3.isBookingAddress,
          activeShop = _props3.activeShop,
          className = _props3.className,
          small = _props3.small;

      var displayValue = void 0;
      if (!!(activeShop && activeShop.addressDisplay)) {
        displayValue = activeShop.addressDisplay;
      } else if (activeShop) {
        displayValue = activeShop.address || activeShop.name;
      }

      return _react2.default.createElement(
        'div',
        { className: styles.box },
        _react2.default.createElement(
          'div',
          {
            className: styles.select + ' ' + styles.active + ' ' + className + ' ' + (disable ? styles.disable : '') + ' ' + (small ? styles.smallSelect : ''),
            onClick: this.onShow
          },
          _react2.default.createElement('img', { src: _Images2.default.account.addressActive }),
          !!(activeShop && (activeShop.addressDisplay || activeShop.address || activeShop.name)) ? _react2.default.createElement(
            'span',
            { className: styles.value },
            displayValue
          ) : _react2.default.createElement(
            'span',
            { className: styles.placeHolder },
            placeHolder
          ),
          !!(activeShop && (activeShop.addressDisplay || activeShop.address || activeShop.name)) && _react2.default.createElement(
            'div',
            { className: styles.btnClear, onClick: this.onClear },
            'x'
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.boxArrow,
              style: { border: isBookingAddress ? 'none' : '1px solid' }
            },
            _react2.default.createElement('i', { className: 'fa fa-sort-desc' })
          )
        )
        //  (
        //   <div className={styles.select} onClick={onShow}>
        //     <img src={Images.account.address} />
        //     <span className={styles.placeHolder}>{placeHolder}</span>
        //     <div className={styles.boxArrow}>
        //       <i className="fa fa-sort-desc"></i>
        //     </div>
        //   </div>
        // )
        ,
        this.renderData()
      );
    }
  }]);
  return SelectShop;
}(_react.Component), _class.propTypes = {
  // @data
  show: _react.PropTypes.bool,
  value: _react.PropTypes.string,
  activeShop: _react.PropTypes.object,
  active: _react.PropTypes.bool,
  placeHolder: _react.PropTypes.string,
  data: _react.PropTypes.array,
  isBookingAddress: _react.PropTypes.bool,
  small: _react.PropTypes.bool,
  disable: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  titleOverlay: _react.PropTypes.string,
  // @action
  onClick: _react.PropTypes.func,
  onShow: _react.PropTypes.func,
  onHide: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onClear: _react.PropTypes.func
}, _temp);
exports.default = SelectShop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/SelectShop.js
// module id = 1568
// module chunks = 0